import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { useStoreContext } from 'state/store';

import { MainMenuProvider, useMainMenuContext } from '../main-menu';
import { MenuOptionsProvider, useMenuOptionsContext } from '../menu-options';
import { MenuUIProvider } from '../menu-ui';

export type Menu = ReturnType<typeof useMainMenuContext> &
  ReturnType<typeof useMenuOptionsContext> & {
    showBurgersForBreakfast: boolean;
  };

export const useMenuContext = (currentUrl?: string): Menu => {
  const menuCtx = useMainMenuContext();
  const menuOptionsCtx = useMenuOptionsContext();

  const { isStoreOpenAndAvailable, store } = useStoreContext();
  const showBurgersForBreakfast = isStoreOpenAndAvailable && store?.hasBurgersForBreakfast === true;

  return {
    ...menuCtx,
    ...menuOptionsCtx,
    showBurgersForBreakfast,
  };
};

export const MenuProvider = ({ children }: IBaseProps) => {
  return (
    <MainMenuProvider>
      <MenuOptionsProvider>
        <MenuUIProvider>{children}</MenuUIProvider>
      </MenuOptionsProvider>
    </MainMenuProvider>
  );
};
